var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvSunIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 5H18.3333V8.33333H21.6667V5Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 8.33333H31.6667V11.6667H28.3333V8.33333Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667H25V15H15V11.6667Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H11.6667V15H15V25Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25V28.3333H15V25H25Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H28.3333V15H25V25Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 18.3333H18.3333V21.6667H21.6667V18.3333Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 8.33333H11.6667V11.6667H8.33333V8.33333Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 18.3333H5V21.6667H8.33333V18.3333Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 28.3333H11.6667V31.6667H8.33333V28.3333Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 31.6667H18.3333V35H21.6667V31.6667Z",
    fill: "#474350"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 28.3333H31.6667V31.6667H28.3333V28.3333Z",
    fill: "#474350"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.3333H31.6667V21.6667H35V18.3333Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvSunIcon);
export default __webpack_public_path__ + "static/media/cv_sun_icon.f764f8b5e76756f6a51a45883aed79f0.svg";
export { ForwardRef as ReactComponent };